import initialState from './initialState';
import _ from 'lodash';

// Constants
const TOKEN_SET = 'TokenSet';

/**
 * Mutations expect two parameters
 * @param {*} state - current state from the store created through VueX
 * @param {*} payload - the data with which the state should be updated. All updates must be in one payload
 */

/* --- APP MUTATIONS --- */

/**
* Commit isActive status and key for the expanded tooltip.
*/
const SHOW_TOOLTIP_EXPANDED = (state, payload) => {
  if (!payload) {
    return;
  }

  state.tooltips.expanded.isActive = true;
  state.tooltips.expanded.key = payload.key;
  state.tooltips.expanded.containerPosition = payload.containerPosition;
  state.tooltips.expanded.scrollDelta = payload.scrollDelta;
};

/**
 * Commit isActive status for expanded tooltip.
 */
const HIDE_TOOLTIP_EXPANDED = (state) => {
  state.tooltips.expanded.isActive = false;
  state.tooltips.expanded.key = '';
  state.tooltips.expanded.containerPosition = undefined;
  state.tooltips.expanded.scrollDelta = 0;
};

const ADD_ERROR = (state, payload) => {
  state.error = payload;
};

/**
 * Sets the redirect type to determine content to show on the redirect page.
 */
const SET_REDIRECT_TYPE = (state, payload) => {
  if (!payload) {
    return;
  }
  state.redirect = payload.redirect;
}

/**
 * Commit policyNumber and zipCode, used to identify a policy
 * and retrieve an access token to make requests for the policy.
 */
const SET_POLICY_IDENTIFIERS = (state, payload) => {
  if (!payload) {
    return;
  }
  state.policyNumber = payload.policyNumber;
  state.zipCode = payload.zipCode;
}

/**
 * Commits test mode (boolean) to VueX store
 */
const SET_TEST_MODE = (state, payload) => {
  state.testMode = payload;
};

/**
 * Commits insurance type to VueX store
 */
const FETCH_INSURANCE_TYPE_SUCCESS = (state, payload) => {
  if (!payload) {
    return;
  }
  state.insuranceType = Object.assign({}, payload);
};

/**
 * Stores key used to request insurance type in advance of request being completed
 */
const INSURANCE_TYPE_REQUESTED = (state, payload) => {
  if (!payload) {
    return;
  }
  state.insuranceType = Object.assign({ key: payload });
};

/* --- POLICY MUTATIONS --- */

const FETCH_POLICY_BALANCE_INFO_SUCCESS = (state, payload) => {
  if (!payload) {
    return;
  }
  state.policyDetails = _.merge(state.policyDetails, payload);
};

/* --- PAYMENT MUTATIONS --- */

const ADD_PAYMENT_INFO = (state, payload) => {
  if (payload.type === 'Card') {
    payload.cardInfo.expiration = payload.cardInfo.expirationMonth +
      payload.cardInfo.expirationYear.substr(2, 2);
  }
  state.payment = Object.assign({}, payload);
};

const CREATE_PAYMENT_RESOURCE_SUCCESS = (state, payload) => {
  state.paymentResource = payload;
};

const UPDATE_PAYMENT_RESOURCE_SUCCESS = (state, payload) => {
  state.paymentResource = payload;
};

const POPULATE_STATE = (state, payload) => {
  state.policyDetails = _.get(payload, 'policyDetails');
  state.payment = _.get(payload, 'payment');
  state.maintenanceMode = _.get(payload, 'maintenanceMode');
  state.returnUrl = _.get(payload, 'returnUrl');
  state.tooltips = _.get(payload, 'tooltips');
  state.paymentResource = _.get(payload, 'paymentResource');
  state.zipCode = _.get(payload, 'zipCode');
  state.policyNumber = _.get(payload, 'policyNumber');
  state.error = _.get(payload, 'error');
  state.redirect = _.get(payload, 'redirect');
  state.insuranceType = _.get(payload, 'insuranceType');
};

const RESET_STATE = (state) => {
  state.policyDetails = _.cloneDeep(initialState.policyDetails);
  state.payment = _.cloneDeep(initialState.payment);
  state.maintenanceMode = _.cloneDeep(initialState.maintenanceMode);
  state.returnUrl = _.cloneDeep(initialState.returnUrl);
  state.tooltips = _.cloneDeep(initialState.tooltips);
  state.paymentResource = _.cloneDeep(initialState.paymentResource);
  state.zipCode = _.cloneDeep(initialState.zipCode);
  state.policyNumber = _.cloneDeep(initialState.policyNumber);
  state.error = _.cloneDeep(initialState.error);
  state.redirect = _.cloneDeep(initialState.redirect);
};

/**
 * This mutation looks to reset user transaction data (policyDetails, payment, paymentResource, zipCode, policyNumber, error, redirect)
 * this will happen when the user click on the Cancel transaction button
 */
const RESET_USER_TRANSACTION_DATA = (state) => {
  state.policyDetails = _.cloneDeep(initialState.policyDetails);
  state.payment = _.cloneDeep(initialState.payment);
  state.paymentResource = _.cloneDeep(initialState.paymentResource);
  state.zipCode = _.cloneDeep(initialState.zipCode);
  state.policyNumber = _.cloneDeep(initialState.policyNumber);
  state.error = _.cloneDeep(initialState.error);
  state.redirect = _.cloneDeep(initialState.redirect);
};

const REMOVE_USER_PAYMENT_DATA = (state) => {
  let initPaymentData = _.cloneDeep(initialState.payment);
  state.payment = initPaymentData;
};

const REMOVE_TOKEN_SESSION_STORAGE = () => {
  sessionStorage.removeItem(TOKEN_SET);
};

/**
 * Update returnUrl for processing-payment with the insuranceType.key
 */
const UPDATE_RETURN_URL = (state, payload) => {
  state.returnUrl = state.returnUrl + `?ins=${payload}`;
}

export default {
  // App Mutations
  SHOW_TOOLTIP_EXPANDED,
  HIDE_TOOLTIP_EXPANDED,
  ADD_ERROR,
  SET_REDIRECT_TYPE,
  SET_POLICY_IDENTIFIERS,
  SET_TEST_MODE,
  FETCH_INSURANCE_TYPE_SUCCESS,
  INSURANCE_TYPE_REQUESTED,
  // Policy Mutations
  FETCH_POLICY_BALANCE_INFO_SUCCESS,
  // Payment Mutations
  ADD_PAYMENT_INFO,
  CREATE_PAYMENT_RESOURCE_SUCCESS,
  UPDATE_PAYMENT_RESOURCE_SUCCESS,
  // Update the store from existing data
  POPULATE_STATE,
  // Reset State
  RESET_STATE,
  RESET_USER_TRANSACTION_DATA,
  REMOVE_USER_PAYMENT_DATA,
  REMOVE_TOKEN_SESSION_STORAGE,
  UPDATE_RETURN_URL
}



// WEBPACK FOOTER //
// ./src/store/mutations.js